import type { ReactNode } from "react";

export type IpIconName =
  | "grid" | "factory" | "cart" | "bank" | "bolt" | "heart" | "dots" | "database" | "gear"
  | "shield" | "nodes" | "sparkle" | "leaf" | "cloud" | "people" | "bars";

const paths: Record<IpIconName, ReactNode> = {
  grid: <><rect x="5" y="5" width="11" height="11" rx="2" /><rect x="20" y="5" width="11" height="11" rx="2" /><rect x="5" y="20" width="11" height="11" rx="2" /><rect x="20" y="20" width="11" height="11" rx="2" /></>,
  factory: <><path d="M4 31h28M7 31V20l7 4v-6l7 4v-6l8 4v15" /><path d="M9 14l5-5 4 3 6-6" /></>,
  cart: <><path d="M3 6h5l3 16h17l3-12H10" /><circle cx="14" cy="29" r="2" /><circle cx="26" cy="29" r="2" /><path d="M16 12l3 3 5-5" /></>,
  bank: <path d="M3 13L18 4l15 9zM7 16v11M14 16v11M22 16v11M29 16v11M4 30h28M3 33h30" />,
  bolt: <path d="M20 3L7 20h10l-2 13 14-18H19z" />,
  heart: <><path d="M18 31S4 23 4 13a7 7 0 0114-1 7 7 0 0114 1c0 10-14 18-14 18z" /><path d="M9 17h5l2-4 3 7 2-3h6" /></>,
  dots: <><circle cx="7" cy="18" r="2" fill="currentColor" /><circle cx="18" cy="18" r="2" fill="currentColor" /><circle cx="29" cy="18" r="2" fill="currentColor" /></>,
  database: <path d="M8 9c0-2.2 4.5-4 10-4s10 1.8 10 4-4.5 4-10 4S8 11.2 8 9zM8 9v18c0 2.2 4.5 4 10 4s10-1.8 10-4V9M8 18c0 2.2 4.5 4 10 4s10-1.8 10-4" />,
  gear: <><circle cx="18" cy="18" r="5" /><path d="M18 4v4M18 28v4M4 18h4M28 18h4M8 8l3 3M25 25l3 3M28 8l-3 3M11 25l-3 3" /></>,
  shield: <><path d="M18 3l12 5v9c0 8-5 13-12 16C11 30 6 25 6 17V8z" /><path d="M12 18l4 4 8-8" /></>,
  nodes: <><circle cx="18" cy="18" r="3.5" /><circle cx="7" cy="9" r="3" /><circle cx="29" cy="9" r="3" /><circle cx="7" cy="27" r="3" /><circle cx="29" cy="27" r="3" /><path d="M9.5 11l6 5M26.5 11l-6 5M9.5 25l6-5M26.5 25l-6-5" /></>,
  sparkle: <><path d="M16 5l3 8 8 3-8 3-3 8-3-8-8-3 8-3z" /><path d="M28 4v6M25 7h6M29 24v5M26.5 26.5h5" /></>,
  leaf: <><path d="M6 30C6 14 16 6 32 5c0 16-7 25-22 25" /><path d="M6 30c4-8 9-13 16-17" /></>,
  cloud: <path d="M10 29a7 7 0 01-1-14 9 9 0 0117-2 6 6 0 01-1 16z" />,
  people: <><circle cx="18" cy="9" r="4" /><circle cx="7" cy="14" r="3" /><circle cx="29" cy="14" r="3" /><path d="M10 31v-5a8 8 0 0116 0v5M2 26v-3a5 5 0 016-4M34 26v-3a5 5 0 00-6-4" /></>,
  bars: <path d="M6 31V21M14 31V13M22 31V8M30 31V17" strokeWidth={3.4} />,
};

export default function IpIcon({ name, size = 30 }: { name: IpIconName; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 36 36" fill="none" stroke="currentColor" strokeWidth={1.7}
      strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      {paths[name]}
    </svg>
  );
}
